/**
 * Hand a fetched blob to the browser as a download.
 *
 * The anchor is attached to the document and the object URL is released on the
 * next frame rather than on the next statement: a detached link is ignored by
 * some browsers, and revoking synchronously after `click()` can cancel the save
 * before it starts.
 */
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  requestAnimationFrame(() => {
    link.remove()
    URL.revokeObjectURL(url)
  })
}
